var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gov_school") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gov_School",
    "data-name": "Gov School"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.97 105.16 40.03 105.16 40.03 50.5 65 35.47 89.97 50.5 89.97 105.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,64A9,9,0,1,0,64,54.91,9,9,0,0,0,55,64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.18,
    y: 86.65,
    width: 18.87,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.13,
    y: 63.96,
    width: 23.9,
    height: 41.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.97,
    y: 63.96,
    width: 23.9,
    height: 41.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.04,
    y1: 63.96,
    x2: 64.04,
    y2: 58.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.32,
    y: 20.5,
    width: 1.51,
    height: 15.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "65.83 20.5 80.09 20.5 80.09 29.75 65.83 29.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.42,
    y: 73,
    width: 7.01,
    height: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.57,
    y: 73,
    width: 7.01,
    height: 8.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.34,
    y: 105.16,
    width: 107.32,
    height: 4.34
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovSchool);
export default __webpack_public_path__ + "static/media/gov_school.af1e063819ed2bb2b3811e5687540b6e.svg";
export { ForwardRef as ReactComponent };